import { render, staticRenderFns } from "./DealsReports.vue?vue&type=template&id=5509464d&scoped=true&"
import script from "./DealsReports.vue?vue&type=script&lang=js&"
export * from "./DealsReports.vue?vue&type=script&lang=js&"
import style0 from "./DealsReports.vue?vue&type=style&index=0&id=5509464d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509464d",
  null
  
)

export default component.exports